import React from "react";

import { DEAL_TYPE_KEYS, ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { useScroll } from "@FillInTableContainer/components/FillInTable/hooks/useScroll";
import TableCreatorGroupTableTitle from "@FillInTableContainer/shared/components/TableCreatorGroupTableTitle/TableCreatorGroupTableTitle";
import { useCurrentDealTypeValue } from "@FillInTableContainer/shared/context/CurrentDealTypeContext";
import { useCanEditGroupTable } from "@FillInTableContainer/shared/hooks/useCanEditGroupTable";

import DealLaScFinancialTermsGroupTable from "./components/DealLaScFinancialTermsGroupTable/DealLaScFinancialTermsGroupTable";
import DealLaScRightsScopeGroupTable from "./components/DealLaScRightsScopeGroupTable/DealLaScRightsScopeGroupTable";
import DealLaScPartnerAxisGroupTable from "./components/DealLaScSingleTable/components/DealLaScPartnerAxisGroupTable/DealLaScPartnerAxisGroupTable";
import DealLaScSingleTable from "./components/DealLaScSingleTable/DealLaScSingleTable";
import {
  DEAL_LA_SC_ADDITIONAL_INFORMATION_TABLE_LAYOUT,
  DEAL_LA_SC_ADVISOR_TABLE_LAYOUT,
  DEAL_LA_SC_DEAL_PURPOSE_TABLE_LAYOUT,
  DEAL_LA_SC_FINANCIAL_TERMS_TABLE_LAYOUT,
  DEAL_LA_SC_OTHER_FINANCIAL_TERMS_TABLE_LAYOUT,
  DEAL_LA_SC_RIGHTS_SCOPE_TABLE_LAYOUT,
} from "./constants/dealLaScDealTermsGroupTableLayout";
import * as S from "./DealLaScDealTermsGroupTable.style";

const groupTableIndex = 5;
const groupTableKey = "Deal Terms & Additional Information";
const articleSection = ENTRY_DATA_SECTION_KEYS.dealsLaSc;

const dealPurposeTableList = DEAL_LA_SC_DEAL_PURPOSE_TABLE_LAYOUT;
const otherFinancialTermsTableList =
  DEAL_LA_SC_OTHER_FINANCIAL_TERMS_TABLE_LAYOUT;
const dealAdditionalInformationTableList =
  DEAL_LA_SC_ADDITIONAL_INFORMATION_TABLE_LAYOUT;

const financialTermsTableList = DEAL_LA_SC_FINANCIAL_TERMS_TABLE_LAYOUT;
const advisorTableList = DEAL_LA_SC_ADVISOR_TABLE_LAYOUT;
const rightsScopeTableList = DEAL_LA_SC_RIGHTS_SCOPE_TABLE_LAYOUT;
const DealLaScDealTermsGroupTable = () => {
  const { register } = useScroll();

  const { checkDisableEdit } = useCanEditGroupTable(articleSection);

  const { isMergeAndAcquisition, currentDealTypeList } =
    useCurrentDealTypeValue();

  if (isMergeAndAcquisition) return null;
  if (currentDealTypeList.includes(DEAL_TYPE_KEYS.ventureFormation)) {
    return null;
  }

  return (
    <>
      <S.GroupTableWrapper
        isDisableEdit={checkDisableEdit(groupTableKey)}
        {...register("Deal Terms & Additional Information (New)")}
      >
        <TableCreatorGroupTableTitle
          title="Deal Terms & Additional Information (New)"
          isRequired={false}
          titleColor="#11AC45"
        />
        <S.TableCreatorTableListWrapper
          isDisableEdit={checkDisableEdit(groupTableKey)}
        >
          {dealPurposeTableList.map(
            ({ tableKey, groupShellList }, tableIndex) => (
              <>
                <DealLaScSingleTable
                  key={`table-${String(groupTableIndex)}-${String(tableIndex)}`}
                  tableKey={tableKey}
                  groupShellList={groupShellList}
                  groupTableKey={groupTableKey}
                  groupTableIndex={groupTableIndex}
                  tableIndex={tableIndex}
                />
              </>
            ),
          )}
          <DealLaScPartnerAxisGroupTable
            groupTableIndex={groupTableIndex}
            groupTableKey={groupTableKey}
          />
          <DealLaScRightsScopeGroupTable
            groupTableKey="Rights Scope Table"
            tableList={rightsScopeTableList}
            groupTableIndex={groupTableIndex}
          />
          <DealLaScFinancialTermsGroupTable
            groupTableKey="Main Financial Terms Table"
            tableList={financialTermsTableList}
            groupTableIndex={groupTableIndex}
          />
          <DealLaScFinancialTermsGroupTable
            groupTableKey="Other Financial Terms"
            tableList={otherFinancialTermsTableList}
            groupTableIndex={groupTableIndex}
          />
          <DealLaScFinancialTermsGroupTable
            groupTableKey="Advisor Table"
            tableList={advisorTableList}
            groupTableIndex={groupTableIndex}
          />
          {dealAdditionalInformationTableList.map(
            ({ tableKey, groupShellList }, tableIndex) => (
              <>
                <DealLaScSingleTable
                  key={`table-${String(groupTableIndex)}-${String(tableIndex)}`}
                  tableKey={tableKey}
                  groupShellList={groupShellList}
                  groupTableKey={groupTableKey}
                  groupTableIndex={groupTableIndex}
                  tableIndex={tableIndex}
                />
              </>
            ),
          )}
        </S.TableCreatorTableListWrapper>
      </S.GroupTableWrapper>
    </>
  );
};

export default DealLaScDealTermsGroupTable;
